
import Vue from "vue";
import { ViewSidebarBlock } from "@/utils/views/view-sidebar";
import { Model } from "@/utils/models/model";
import { IResolvedSidebarField, resolveSidebarFieldValue } from "@/utils/views/sidebar-field-value";

export default Vue.extend({
	props: {
		block: {
			type: Object as () => ViewSidebarBlock,
			required: true
		},
		item: {
			type: Object as () => any,
			required: true
		},
		model: {
			type: Object as () => Model,
			required: true
		}
	},
	computed: {
		rows():IResolvedSidebarField[] {
			return this.block.Fields.map(f=>resolveSidebarFieldValue(f, this.item, this.model));
		},
		summary():string {
			let first = this.rows.find(r=>r.text != "");
			return first ? first.text : "";
		}
	},
	watch: {
		summary: {
			immediate: true,
			handler(){
				this.$emit("summary", this.summary);
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
